import { render } from "./EmbargosGobernacionCrearActualizarComponent.vue?vue&type=template&id=6f77a99c"
import script from "./EmbargosGobernacionCrearActualizarComponent.vue?vue&type=script&lang=js"
export * from "./EmbargosGobernacionCrearActualizarComponent.vue?vue&type=script&lang=js"

import "./EmbargosGobernacionCrearActualizarComponent.vue?vue&type=style&index=0&id=6f77a99c&lang=css"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__